import React, { useState, useEffect, useRef } from "react";

function ProductMeta({ type, colors, sizes }) {
    const parts = [];
    if (type) parts.push(type);
    if (colors?.length) parts.push(colors.join(", "));
    if (sizes?.length) parts.push(sizes.join(", "));
    if (!parts.length) return null;
    return <small className="text-muted ms-1">{parts.join(" · ")}</small>;
}

const ProductAutocomplete = ({ products, onSelect }) => {
    const [query, setQuery] = useState("");
    const [filtered, setFiltered] = useState([]);
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (!query.trim()) {
            setFiltered([]);
            return;
        }
        const q = query.toLowerCase();
        setFiltered(
            products
                .filter((p) => {
                    if (p.name.toLowerCase().includes(q)) return true;
                    if (p.type?.toLowerCase().includes(q)) return true;
                    if (p.colors?.some((c) => c.toLowerCase().includes(q))) return true;
                    return false;
                })
                .slice(0, 20)
        );
    }, [query, products]);

    return (
        <div ref={wrapperRef} className="position-relative" style={{ width: "100%" }}>
            <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Пошук речей..."
                value={query}
                onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
                onFocus={() => setOpen(true)}
            />

            {open && filtered.length > 0 && (
                <ul
                    className="list-group position-absolute shadow"
                    style={{ top: "calc(100% + 2px)", zIndex: 50, maxHeight: 260, overflowY: "auto", width: "100%", minWidth: 260 }}
                >
                    {filtered.map((item) => (
                        <li
                            key={item.product_id}
                            className="list-group-item list-group-item-action d-flex align-items-baseline gap-1"
                            style={{ cursor: "pointer" }}
                            onClick={() => { onSelect(item); setQuery(""); setOpen(false); }}
                        >
                            <span>{item.name}</span>
                            <small className="text-muted">#{item.product_id}</small>
                            <ProductMeta type={item.type} colors={item.colors} sizes={item.sizes} />
                        </li>
                    ))}
                </ul>
            )}

            {open && query.trim() && filtered.length === 0 && (
                <div
                    className="position-absolute bg-white border rounded p-2 text-muted small"
                    style={{ top: "calc(100% + 2px)", zIndex: 50, width: "100%" }}
                >
                    Нічого не знайдено
                </div>
            )}
        </div>
    );
};

export default ProductAutocomplete;
